import React, { useEffect, useState } from "react";
import { array, object } from "prop-types";
import get from "lodash/get";
import { ClientSideOnly, ResponsiveImage } from "@quintype/components";

import AuthorImg from "../other-icons/AuthorImg";
import { getAAuthor } from "../../helper/api";

import "./author.m.css";

const AuthorAvatar = ({ author }) => {
  const name = author.name;
  const avatarURL = author["avatar-s3-key"];
  const authorAvatarUrl = author["avatar-url"];
  let imageView = null;

  if (avatarURL) {
    imageView = (
      <ResponsiveImage
        styleName="author-img"
        slug={avatarURL}
        aspectRatio={[1, 1]}
        alt={name.substring(1)}
        widths={[50]}
        imgParams={{ auto: ["format", "compress"], fit: "max" }}
      />
    );
  } else if (authorAvatarUrl) {
    imageView = <img styleName="author-img" src={authorAvatarUrl} alt={name.substring(1)} />;
  } else {
    imageView = (
      <div styleName="default-author-img">
        <AuthorImg />
      </div>
    );
  }

  return <ClientSideOnly>{imageView}</ClientSideOnly>;
};

AuthorAvatar.propTypes = {
  author: object
};

const Author = ({ author, lastUpdatedDateAndTime, isDHExclusive, isLastAuthor, index }) => {
  const { slug, name, id } = author;
  const [authorDetails, setAuthorDetails] = useState({});
  const [isMobile, setMobile] = useState(false);
  const authorRoles = [
    get(authorDetails, ["metadata", "is_DHNS"], ""),
    get(authorDetails, ["metadata", "is_DH Web Desk"], "")
  ];

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);
  useEffect(() => {
    async function fetchAuthor() {
      await getAAuthor(id).then(({ author }) => setAuthorDetails(author));
    }
    fetchAuthor();
  }, []);

  return (
    <>
      <div styleName="author-wrapper">
        <div styleName="author-avatar">
          <AuthorAvatar author={author} />
        </div>
        <div styleName={`${isDHExclusive ? "exclusive-timestamp" : "name-time-wrapper"}`}>
          <div styleName="author-text-wrapper">
            <div styleName="author-name">
              <a href={`/author/${slug}`}>{name}</a>
            </div>
            {authorRoles.map((role, index) =>
              ["yes", "Yes", "true", "True", "t", "T"].includes(role) ? (
                <React.Fragment key={index}>
                  <div styleName="small-line"></div>
                  <p styleName="dh-news">{index === 0 ? "DHNS" : "DH Web Desk"}</p>
                </React.Fragment>
              ) : null
            )}
          </div>

          {isLastAuthor && isDHExclusive && !isMobile ? (
            <div styleName={`timestamp ${isDHExclusive ? "ex-timestamp" : ""}`}>
              <div styleName="date">Last Updated : {lastUpdatedDateAndTime} IST</div>
            </div>
          ) : null}
        </div>
      </div>

      {isDHExclusive && isLastAuthor && isMobile ? (
        <div styleName="timestamp">
          <div styleName="date">Last Updated : {lastUpdatedDateAndTime} IST</div>
        </div>
      ) : null}
      {/* {!isMobile && !isDHExclusive ? (
        <div styleName="timestamp">
          <div styleName="date">Last Updated : {lastUpdatedDateAndTime} IST</div>
        </div>
      ) : null}  */}
    </>
  );
};

Author.propTypes = {
  author: object
};

const Authors = ({ authors, lastUpdatedDateAndTime, isDHExclusive }) => {
  console.log("Authors>>", authors.length - 1);
  return (
    <>
      <div styleName="authors-wrapper">
        {authors &&
          authors.map((author, index) => {
            return (
              <div key={index}>
                <Author
                  author={author}
                  lastUpdatedDateAndTime={lastUpdatedDateAndTime}
                  isDHExclusive={isDHExclusive}
                  isLastAuthor={index === authors.length - 1}
                  index={index}
                />
              </div>
            );
          })}
      </div>
      {!isDHExclusive && (
        <div styleName="timestamp" id="change">
          <div styleName="date">Last Updated : {lastUpdatedDateAndTime} IST</div>
        </div>
      )}
    </>
  );
};

Authors.propTypes = {
  authors: array
};

export default Authors;
